import constants from '@client-shared/config/constants.js'
import { sortItemsByLocationLayerOrder } from '@client-shared/utils/sort-functions.js'

// Comparator that only decides which group a photo belongs to. Callers combine it with
// getPhotoSortFunction (`groupFunction(a, b) || sortFunction(a, b)`) so photos of the same group
// stay in the chosen sort order - without it PhotoList renders a group title per run of photos.
export default ({ groupBy, project, locationLayers = [] }) => {
  // A missing groupBy would silently return the no-op comparator and look like "grouping is
  // broken", so reject it up front instead.
  if (!groupBy) {
    throw new Error('getPhotoGroupFunction: groupBy is required')
  }

  // project stays optional on purpose: groupBy is persisted, so a user who left the list grouped by
  // album re-enters it before project.project resolves from null. Album order comes from
  // project.photoAlbums, so there is genuinely nothing to group by yet - the caller re-runs once the
  // project arrives. Same for locationLayers, which starts out as an empty list.
  if (groupBy === constants.PHOTOS_LIST_GROUPING.GROUP_BY_ALBUM && project) {
    return (a, b) => {
      const aIndexOf = project.photoAlbums.indexOf(a.album)
      const bIndexOf = project.photoAlbums.indexOf(b.album)

      if (aIndexOf === bIndexOf) { return 0 }

      return aIndexOf > bIndexOf ? 1 : -1
    }
  }

  if (groupBy === constants.PHOTOS_LIST_GROUPING.GROUP_BY_LOCATION_LAYER) {
    return sortItemsByLocationLayerOrder.bind({ locationLayers })
  }

  return () => 0
}
